import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Typography, Box } from "@mui/material";
import Signup from "./pages/Signup";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";
import CookieConsent from "./components/CookieConsent";

const API_ORIGIN = (process.env.REACT_APP_API_URL || "http://localhost:8080").replace(/\/$/, "");

// Track page views on client-side route changes (only fires if scripts were loaded via consent)
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-43JS5VRZ5T', { page_path: location.pathname + location.search });
    }
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);
  return null;
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#2e7d32",
    },
    background: {
      default: "#f5f7fa",
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
        },
      },
    },
  },
});

function App() {
  const [version, setVersion] = useState("");

  useEffect(() => {
    fetch(`${API_ORIGIN}/api/version`)
      .then((res) => res.json())
      .then((data) => setVersion(data.version))
      .catch(() => setVersion(""));
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Signup />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
        </Routes>
        <CookieConsent />
      </Router>
      {version && (
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Typography variant="caption" color="text.disabled">
            v{version}
          </Typography>
        </Box>
      )}
    </ThemeProvider>
  );
}

export default App;
